export enum TypeOfOrder {
  FullyAccepted = '#136207',
  PartlyAccepted = '#FFAA07',
  ToHighAccepted = '#DA1515',
  ShortDateAccepted = '#FFF',
}
